import { render } from "./ImportExcelBasicLayout.vue?vue&type=template&id=e67f69d0"
import script from "./ImportExcelBasicLayout.vue?vue&type=script&lang=js"
export * from "./ImportExcelBasicLayout.vue?vue&type=script&lang=js"

import "./ImportExcelBasicLayout.vue?vue&type=style&index=0&id=e67f69d0&lang=css"
script.render = render

export default script